import { Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateOrganizationMutation } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../../common/errors/useApiError";
import { TipTap } from "../../../../common/input/TipTap/TipTap";
import { useAppDispatch } from "../../../../common/redux/hooks";
import { updateSelectedOrg } from "../../../../common/redux/reducers/authStateReducer";

interface Props {
  currentValue: string;
}

export const ChangeAboutUs = ({ currentValue }: Props) => {
  const authState = useLoggedInWithOrgContextState();
  const [editOrg] = useUpdateOrganizationMutation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const displayer = useApiError();
  const [initialContent] = useState<string>(currentValue);

  const save = async (value: string) => {
    try {
      const data = await editOrg({
        orgId: authState.selectedOrg.id,
        editOrganizationRequest: { aboutUs: { value } },
      }).unwrap();
      dispatch(updateSelectedOrg(data));
    } catch (e) {
      displayer.trigger(e);
    }
  };

  return (
    <>
      <Text fontWeight="medium" pt="5">
        {t("About us")}
      </Text>
      <TipTap content={initialContent} onUpdate={save} />
    </>
  );
};
